import { render, staticRenderFns } from "./FooterAppStats.vue?vue&type=template&id=d3610f3a&"
import script from "./FooterAppStats.vue?vue&type=script&lang=js&"
export * from "./FooterAppStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports